import React from 'react'
import {Link} from '../'

class LinksTester extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    return (
      <div className="LinksTester">
        <a href="/test-playground/forms" className="sr2">Forms (href link)</a>
        <Link to="/test-playground/dialogs" className="sr2">Dialogs (Pushstate Link)</Link>
        <a href="/test-playground/caches" className="sr2">Caches (href link)</a>
        <Link href="/test-playground/formsubmission" className="sr2">Form Submissions</Link>
        <Link href="/test-playground/iframe" className="sr2">IFrames</Link>
        <Link href="/test-playground/fileupload">File Input</Link>
        <Link href="/test-playground/tabs">Tabs</Link>
        <Link href="/test-playground/miscellaneous">Miscellaneous</Link>
      </div>
    )
  }

}

export default LinksTester;



// WEBPACK FOOTER //
// ./src/components/testplayground/LinksTester.js